import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { IoIosClose, IoIosMenu } from 'react-icons/io';
import { FaArrowRight } from 'react-icons/fa';
import './TopNavBar.css';

const TopNavBar = () => {
  const [showBanner, setShowBanner] = useState(true);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 12);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = isMobileMenuOpen ? 'hidden' : '';
  }, [isMobileMenuOpen]);

  const closeMenu = () => setIsMobileMenuOpen(false);

  return (
    <div className="fh-nav-wrap">
      {showBanner && (
        <div className="fh-banner">
          <span>
            <span style={{ marginRight: 8 }}>🌙</span>
            Pilot program is open. Partner with us before Ramadan 2026.
            <Link to="/pricing" className="fh-banner-link"> See terms →</Link>
          </span>
          <button onClick={() => setShowBanner(false)} className="fh-banner-close" aria-label="Close banner">
            <IoIosClose />
          </button>
        </div>
      )}

      <nav className={`fh-nav ${isScrolled ? 'is-scrolled' : ''}`}>
        <div className="fh-nav-inner">
          <Link to="/" className="fh-nav-logo" onClick={closeMenu}>
            <span className="fh-nav-logo-mark">f</span>
            <span className="fh-nav-logo-text">findhalal<span className="fh-nav-logo-inc">Inc.</span></span>
          </Link>

          <div className="fh-nav-links">
            <Link to="/" className="fh-nav-link">Home</Link>
            <Link to="/about" className="fh-nav-link">About</Link>
            <Link to="/pricing" className="fh-nav-link">Partner</Link>
            <Link to="/contact" className="fh-nav-link">Contact</Link>
          </div>

          <div className="fh-nav-actions">
            <Link to="/pricing" className="fh-nav-cta">
              Partner with us <FaArrowRight />
            </Link>
            <button
              className="fh-nav-toggle"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Toggle menu"
            >
              {isMobileMenuOpen ? <IoIosClose /> : <IoIosMenu />}
            </button>
          </div>
        </div>
      </nav>

      {isMobileMenuOpen && (
        <div className="fh-mobile-menu">
          <Link to="/" className="fh-mobile-link" onClick={closeMenu}>Home</Link>
          <Link to="/about" className="fh-mobile-link" onClick={closeMenu}>About</Link>
          <Link to="/pricing" className="fh-mobile-link" onClick={closeMenu}>Partner with us</Link>
          <Link to="/contact" className="fh-mobile-link" onClick={closeMenu}>Contact</Link>
          <Link to="/help" className="fh-mobile-link" onClick={closeMenu}>Help Center</Link>
          <Link to="/pricing" className="fh-btn fh-btn-primary" onClick={closeMenu} style={{ marginTop: 12 }}>
            Partner with us <FaArrowRight />
          </Link>
        </div>
      )}
    </div>
  );
};

export default TopNavBar;
